import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function SuccessPageStripe() {
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState("");
    const [plan, setPlan] = useState("");
    const [amount, setAmount] = useState("");
    const [email, setEmail] = useState("");

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const verifySession = async () => {
            try {
                const sessionId = searchParams.get("session_id");
                if (!sessionId) {
                    setStatus("error");
                    setMessage("Session ID nije pronađen.");
                    setLoading(false);
                    return;
                }

                const response = await axios.get(`/stripe/verify-session?session_id=${sessionId}`);
                const { customer_email, amount_total, planType } = response.data;

                setEmail(customer_email);
                setAmount((amount_total / 100).toFixed(2));
                setPlan(planType);
                setStatus("success");
            } catch (err) {
                setStatus("error");
                setMessage("Provjera plaćanja nije uspjela.");
            } finally {
                setLoading(false);
            }
        };

        verifySession();
    }, [searchParams]);

    if (loading)
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50 text-gray-600 text-lg">
                {t('checkingPayment')}
            </div>
        );

    if (status === "error")
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-gray-700">
                <h1 className="text-2xl font-semibold mb-4">{t('paymentFailed')}</h1>
                <p className="mb-6">{message}</p>
                <button onClick={() => navigate("/")} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                    {t('backToHome')}
                </button>
            </div>
        );

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-gray-700">
            <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md text-center">
                <h1 className="text-3xl font-bold text-green-600 mb-4">{t('paymentSuccess')}</h1>
                {email && <p className="text-lg mb-2">{t('thankYou')} {email}</p>}
                <p className="text-gray-600 mb-4">
                    {t('premiumActivated')}
                </p>
                <p className="text-xl font-semibold mb-6">{amount} €</p>

                <button onClick={() => navigate("/organization")} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition">
                    {t('backToDashboard')}
                </button>
            </div>
        </div>
    );
}
